// One link treatment for every auth screen.
//
// These links had drifted into five different styles across the six auth
// pages — some underlined, some not, some semibold, some not. The Figma auth
// flow shows inline links as green semibold with no permanent underline (see
// "Terms and Conditions" and "Login"), so that is the shared treatment. The
// underline appears on hover, which keeps the affordance without the heavy
// look of a static underline.
//
// Font size is deliberately left out: these links sit inside parents that
// already set their own size (text-sm, text-[14px]), and baking one in here
// would override them.
export const AUTH_LINK_CLASS =
  'font-semibold text-bloom-green transition-colors hover:text-bloom-green-hover hover:underline';

export default AUTH_LINK_CLASS;
